module.exports = __webpack_public_path__ + "static/media/algae.7104be31.png";